import { RouteHandler } from 'wee-routes';
import $events from 'wee-events';
import $ from 'wee-dom';

export default new RouteHandler({
    init() {
        $(':file' ).each((el) => {
            let $label	 = $(el).next(),
                labelVal = $label.text();

            $events.on(el, 'change', (e, el) => {
                let fileName = '';

                if (el.files && el.files.length > 1) {
                    fileName = ($(el).attr('data-multiple-caption') || '' ).replace('{count}', el.files.length);
                } else {
                    fileName = e.target.value.split( '\\' ).pop();
                }

                $label.text(fileName || lavelVal);
            });
        });
    }
})